import { useActions } from '@/utils/map-state';
import dayjs from 'dayjs';
import { ref, reactive, computed, onMounted } from 'vue';
import { map, find, filter, intersection, forEach } from 'lodash-es';
import { promoteUrl } from "@/utils/url";
import { Toast } from 'vant';
import * as API from '@/api';
import axios from '@/api/axios';
export default {
  name: "SignPopupPC",
  setup() {
    const commonActions = useActions('common', ['showSignPopup']);
    const isIframe = window.frameElement;
    const isTransformable = isIframe ? isIframe.id === 'i-sign-transformable' : false;
    const state = reactive({
      checkedDayList: [],
      // 已簽到日期
      strToday: +dayjs().format('D'),
      // 今天日期
      // strToday: 26, // 今天日期
      strThisMonth: +dayjs().format('M'),
      // 本月
      signTaskCredit: 0,
      // 本月福米獲得量
      isTransformable: isTransformable,
      isFullPage: !isTransformable
    });
    const toggleSize = () => {
      state.isFullPage = !state.isFullPage;
      parent.postMessage({
        vueIframe: {
          elemtId: isIframe.id,
          action: state.isFullPage ? 'fullpage' : 'not-fullpage'
        }
      });
    };
    // 當月天數
    const daysInMonth = ref(dayjs().daysInMonth());
    // 取得今日位于的行列, 起始与结束日
    const daysInThisWeek = ref((() => {
      const rowCount = 7;
      let start, end;
      const calResult = (state.strToday / rowCount).toString().split('.');
      if (calResult.length === 1) {
        end = state.strToday;
        start = state.strToday - rowCount + 1;
      } else {
        start = +calResult[0] * rowCount + 1;
        end = start + rowCount - 1;
      }
      if (end > daysInMonth.value) end = daysInMonth.value;
      return {
        start,
        end
      };
    })());
    // 填補天數空位
    const fillUpDays = computed(() => {
      return 7 - daysInMonth.value % 7;
    });
    // 今日已簽到
    const todayIsChecked = computed(() => {
      return state.checkedDayList.indexOf(state.strToday) > -1;
    });
    // 日期顯示的文字
    const dayText = text => {
      return state.strToday === text ? '今日' : text;
    };
    // 獎品1日期
    const prizeDay1 = computed(() => {
      // 扣掉今日已簽
      let todayChecked = todayIsChecked.value ? 0 : 1;
      // 簽到天數
      let length = state.checkedDayList.length;
      if (length >= 7) {
        return state.checkedDayList[6];
      } else {
        return state.strToday + (7 - length) - todayChecked;
      }
    });
    // 獎品2日期
    const prizeDay2 = computed(() => {
      // 扣掉今日已簽
      let todayChecked = todayIsChecked.value ? 0 : 1;
      // 簽到天數
      let length = state.checkedDayList.length;
      if (length >= 14) {
        return state.checkedDayList[13];
      } else {
        return state.strToday + (14 - length) - todayChecked;
      }
    });
    // 獎品3日期
    const prizeDay3 = computed(() => {
      // 扣掉今日已簽
      let todayChecked = todayIsChecked.value ? 0 : 1;
      // 簽到天數
      let length = state.checkedDayList.length;
      if (length >= 21) {
        return state.checkedDayList[20];
      } else {
        return state.strToday + (21 - length) - todayChecked;
      }
    });
    // 獎品4日期
    const prizeDay4 = computed(() => {
      // 扣掉今日已簽
      let todayChecked = todayIsChecked.value ? 0 : 1;
      // 簽到天數
      let length = state.checkedDayList.length;
      if (length >= 28) {
        return state.checkedDayList[27];
      } else {
        return state.strToday + (28 - length) - todayChecked;
      }
    });
    // 獎勵與簽到日同一天(已領獎勵)
    const checkedPrize = computed(() => {
      // 取交集
      return intersection(state.checkedDayList, [prizeDay1.value, prizeDay2.value, prizeDay3.value, prizeDay4.value]);
    });
    const close = () => {
      if (isTransformable) {
        toggleSize();
      } else {
        if (isIframe) {
          parent.postMessage({
            vueIframe: {
              elemtId: isIframe.id,
              action: 'close'
            }
          });
        }
        commonActions.showSignPopup({
          'show': false
        });
      }
    };
    onMounted(() => {
      console.log('onMounted');
      getSignInInfo();
    });
    function getSignInInfo(firstTime = true) {
      API.getTaskListAPI().then(res => {
        console.log(res);
        // 當月獲得福米量
        state.signTaskCredit = +res.data.sign_task_credit;
        // 已簽到日期
        let taskSign = find(res.data.sign, o => o.taskid === '1');
        state.checkedDayList = map(taskSign.ext, d => +dayjs(d).format('D'));
        console.log('已簽到日期', state.checkedDayList);
        // 判斷今天是否已簽到，若沒有則簽到
        console.log('是否可簽到', taskSign.allowlingqu, 'firstTime=>', firstTime);
        if (taskSign.allowlingqu === 1 && firstTime) {
          console.log('可簽到，將進行簽到', 'firstTime=>', firstTime);
          // 可簽到
          API.applySignIn().then(res => {
            if (res.status === 0) {
              console.log('签到成功');
              Toast({
                message: '已签到成功，福米将自动发放到您的账户'
              });
              getSignInInfo(false);
            }
          });
        } else {
          console.log('今日已簽到', 'firstTime=>', firstTime);
        }
        // 判斷日否已領取連續簽到獎勵，沒有則領
        let allCanDraw = filter(res.data.accumulate_sign, o => o.allowlingqu === 1);
        console.log('allCanDraw', allCanDraw);
        forEach(allCanDraw, task => {
          console.log('可領取連續簽到 ' + task.num + ' 天獎勵');
          axios.post(promoteUrl() + '/home.php?mod=task_ajax&a=draw&id=' + task.taskid + '&v=vue').then(res => {
            if (res.status === 0) {
              console.log('領取連續簽到 ' + task.num + ' 天獎勵成功');
            }
          });
        });
      });
    }
    return {
      state,
      daysInThisWeek,
      daysInMonth,
      fillUpDays,
      dayText,
      prizeDay1,
      prizeDay2,
      prizeDay3,
      prizeDay4,
      checkedPrize,
      toggleSize,
      close
    };
  }
};